import { createSelector } from 'reselect'
import { getPolicyValues } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'

export const getPolicyValueTableBenefits = createSelector(
  getSelectedDisplayProduct,
  getPolicyValues,
  (displayProduct, policyValue) => ({
    basicPlan: displayProduct,
    policyValue,
  })
)
